import _ from 'lodash'

let defaults = [
  {
    name: 'string',
    items: [
      { value: 'equals', text: 'برابر باشد با' },
      { value: 'contains', text: 'شامل باشد' }
    ]
  },
  {
    name: 'number',
    items: [
      { value: 'equals', text: 'برابر باشد با' },
      { value: 'greaterThan', text: 'بزرگتر باشد از' },
      { value: 'lesserThan', text: 'کمتر باشد از' },
      { value: 'greaterThanEqual', text: 'بزرگتر مساوی باشد از' },
      { value: 'lesserThanEqual', text: 'کمتر مساوی باشد از' }
    ]
  },
  {
    name: 'price',
    items: [
      { value: 'equals', text: 'برابر باشد با' },
      { value: 'greaterThan', text: 'بزرگتر باشد از' },
      { value: 'lesserThan', text: 'کمتر باشد از' }
    ]
  },
  {
    name: 'single-choice',
    items: [
      { value: 'equals', text: 'برابر باشد با' },
      { value: 'notEquals', text: 'برابر نباشد با' },
      { value: 'contains', text: 'شامل باشد' },
      { value: 'notContains', text: 'شامل نباشد' }
    ]
  },
  {
    name: 'multi-choice',
    items: [
      { value: 'equals', text: 'برابر باشد با' },
      { value: 'notEquals', text: 'برابر نباشد با' },
      { value: 'contains', text: 'شامل باشد' },
      { value: 'notContains', text: 'شامل نباشد' }
    ]
  }
]

export default function (name, include) {
  let def = _.head(defaults.filter(x => x.name === name))
  let items = (def || {}).items
  if (items && items.length) {
    if (include && Array.isArray(include)) {
      items = items.filter(x => include.indexOf(x.name) > -1)
    }

    return items
  }

  return []
}
